define.alias("shared/models/th-post", "calendar/models/th-post");